import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["startsAt", "endsAt"];

  prefillDates(event) {
    const select = event.target;
    const label = select.options[select.selectedIndex]?.text;
    if (!label) return;

    const match = label.match(
      /\((\d{2}\.\d{2}\.\d{4})\s*–\s*(\d{2}\.\d{2}\.\d{4})\)$/
    );
    if (!match) return;

    if (!this.startsAtTarget.value) {
      this.startsAtTarget.value = this.toISODate(match[1]);
    }
    if (!this.endsAtTarget.value) {
      this.endsAtTarget.value = this.toISODate(match[2]);
    }
  }

  toISODate(germanDate) {
    const [day, month, year] = germanDate.split(".");
    return `${year}-${month}-${day}`;
  }
}
